export enum FeedbackSource {
	EDITOR = 'Editor',
	HELP_PANEL = 'Help Panel',
	THEME_SELECTOR = 'Theme Selector',
	WHITEBOARD = 'Whiteboard',
	EMBED = 'Embed',
	DATABASE = 'Database',
	NAV_4 = 'Nav4',
	SHARE_DIALOG = 'Share Dialog',
	CONTENT_WRAPPER = 'Content Wrapper',
	LIVE_DOCS = 'Live Docs',
	EDITOR_CONTROLS = 'Editor Controls',
	NOTES = 'Notes',
	CREATE_WITH_ROVO = 'Create with Rovo',
	SLIDE = 'Slide',
	TABS = 'Tabs',
}
